module.exports = __webpack_public_path__ + "static/media/plus-grey.d0135deb.svg";